import type { EditTripSegment } from '@apps/main/new-desktop/modules/editTripModal';

import type {
  AutoCompleteSuggestion,
  IngredientId,
} from '@libs/trip-planner-interfaces';

export enum SelectDestinationEmitType {
  AddDestination = 'AddDestination',
  AddDestinationToOwnStay = 'AddDestinationToOwnStay',
  UpdateDestination = 'UpdateDestination',
}

export interface CarTripInfo {
  duration: string;
  distance: string;
}

interface AddDestinationEmit {
  type: SelectDestinationEmitType.AddDestination;
  suggestion: AutoCompleteSuggestion;
}

interface AddDestinationToOwnStayEmit {
  type: SelectDestinationEmitType.AddDestinationToOwnStay;
  suggestion: AutoCompleteSuggestion;
  ingredientId: IngredientId;
}

interface ChangeDestinationEmit {
  type: SelectDestinationEmitType.UpdateDestination;
  suggestion: AutoCompleteSuggestion;
  ingredientId: IngredientId;
}

export type SelectDestinationEmit =
  | AddDestinationEmit
  | AddDestinationToOwnStayEmit
  | ChangeDestinationEmit;

export interface EditTripOverviewStep {
  stepType: EditTripStepType.Overview;
  isInitialStep?: boolean;
}

interface EditTripAddDestinationStep {
  stepType: EditTripStepType.AddDestination;
  isInitialStep?: boolean;
}

interface EditTripUpdateDestinationStep {
  stepType: EditTripStepType.UpdateDestination;
  currentEditingSegment: EditTripSegment;
  isInitialStep?: boolean;
}

interface EditTripAddDestinationToOwnStayStep {
  stepType: EditTripStepType.AddDestinationToOwnStay;
  ownStayDestinationIngredeintId: IngredientId;
  isInitialStep?: boolean;
}
export type EditTripSelectDestinationStep =
  | EditTripAddDestinationStep
  | EditTripUpdateDestinationStep
  | EditTripAddDestinationToOwnStayStep;

export type EditTripStep = EditTripOverviewStep | EditTripSelectDestinationStep;

export enum EditTripStepType {
  Overview = 'Overview',
  AddDestination = 'AddDestination',
  UpdateDestination = 'UpdateDestination',
  AddDestinationToOwnStay = 'AddDestinationToOwnStay',
}
